import { Outlet } from 'react-router-dom';

import usePageTitle from 'lib/hooks/usePageTitle';

import AssetsSidebar from './components/AssetsSidebar';

const Assets = () => {
  usePageTitle('Assets');

  return (
    <div className="flex h-full overflow-hidden bg-neutral-50" data-dd-privacy="allow">
      <AssetsSidebar />
      <div className="flex w-full flex-col">
        <Outlet />
      </div>
    </div>
  );
};

export default Assets;
